﻿// import QRCode from 'qrcode';
var alert = require('./alert');
var evaluate = require('./evaluateAlert');
module.exports = san.defineComponent({
    template: require('../views/qjzxAnswer.html'),
    initData: function () {
        return {
            showLoading: false,
            showAlert: false,
            evaluateAlert: false,
            isAlert: false,
            tipMessage: '',
            seedFail: true,//邮箱发送失败
            email: '',
            emailAddress: '',
            title: '',
            answer: '',
            erweimaSrc: '',
            caseList: [],
            params: {},
            qType: '',
            askType: '',
            uid: '',
            url: '',
            arr: '',
            showCompany: false,
            loading1: false,
        };
    },
    components: {
        'Alert': alert,
        'evaluate': evaluate
    },
    showCompany: function () {
        this.data.set('showCompany', true);
    },
    getBgAnswer: function (i, t) {
        this.data.set('answer', '');
        this.data.set('caseList', '');
        this.data.set('showLoading', true);
        var me = this;
        var data = i.value;
        this.data.set('qType', data.qType);
        this.data.set('askType', t);
        this.data.set('arr', JSON.parse(i.value.arr));
        $.ajax({
            url: window.Apipath.getBgAnswer(t),
            // type:"post",
            dataType: 'json',
            success: function (resp) {
                if (typeof (resp) == "string") {
                    resp = eval("(" + resp + ")");
                }
                resp.forEach(function (item) {
                    if (item.answerId == data.answerId) {
                        me.data.set('showLoading', false);
                        me.data.set('answer', item.content);
                        me.data.set('caseList', item.caseList);
                        me.data.set('answer', me.data.get('answer').replace(/{part1}/g, data.part1));
                        me.data.set('answer', me.data.get('answer').replace(/{part2}/g, data.part2));
                        me.data.set('answer', me.data.get('answer').replace(/{part3}/g, data.part3));
                        me.data.set('answer', me.data.get('answer').replace(/{part4}/g, data.part4));
                        me.data.set('answer', me.data.get('answer').replace(/{part5}/g, data.part5));
                        me.data.set('answer', me.data.get('answer').replace(/{part6}/g, data.part6));
                        me.data.set('answer', me.data.get('answer').replace(/{part7}/g, data.part7));
                        me.data.set('answer', me.data.get('answer').replace(/{part8}/g, data.part8));
                        me.data.set('answer', me.data.get('answer').replace(/{part9}/g, data.part9));
                        me.data.set('answer', me.data.get('answer').replace(/{event1}/g, data.event1));
                        me.data.set('answer', me.data.get('answer').replace(/{event2}/g, data.event2));
                        me.data.set('answer', me.data.get('answer').replace(/{event3}/g, data.event3));
                    }
                });
                me.createEWM();
            },
            error: function (err) {

            }
        });
    },
    reset: function () {
        var me = this;
        this.data.set('showAnswer', 1);
        var qustionList = this.data.get('qustionList');
        for (var l in qustionList) {
            for (var q in qustionList[l].answerList) {
                qustionList[l].answerList[q].checked = false;
            }
            qustionList[l].childrenList.aClass = [];
            qustionList[l].childrenList.bClass = [];
            this.data.set('qustionList[' + l + ']', qustionList[l]);
        }
        this.data.set('answerId', '');
        me.nextTick(function () {
            window.Tool._scroll(me.ref('scroll').scrollTop, 0);
        });
    },
    back: function (t) {
        this.data.set('showAnswer', t);
    },
    goDetail: function (caseName) {
        this.dispatch("getCase", caseName);
    },
    createEWM: function () {
        var answer = JSON.parse(JSON.stringify(this.data.get('answer')));
        if (answer.indexOf("三、参考案例") != -1) {
            answer = answer.replace("三、参考案例", "");
        }
        if (answer.indexOf("四、参考案例") != -1) {
            answer = answer.replace("四、参考案例", "");
        }
        if (answer.indexOf("五、参考案例") != -1) {
            answer = answer.replace("五、参考案例", "");
        }
        var content = '<div class="answer"> <h3>法律咨询意见书</h3> <p style="text-indent: 0">感谢您对我们的信任与支持，以下法律意见书是根据您填写的信息，并参考大量相似案例，汇集众多法律专业人士的智慧形成的，供您参考。</p>' + answer +
            ' <div class="tip"><h4>风险提示与声明</h4><p>1、咨询人填写内容和选择信息应当保证真实性、准确性和完整性，否则意见书可能产生误差。</p>' +
            ' <p>2、本意见书中的结论系我们基于咨询人提供的信息，并应用法律AI技术，所作出的参考性法律意见，不能替代任何司法裁判或其他权力机关的法律文书，亦不可作为证据或用于其他未经许可的相关法律用途。</p><p>3、本意见书内容仅供咨询人参考，相关法律责任均由咨询人自行承担。</p></div></div>';
        var params2 = {
            name: "法律咨询意见书",
            consultType: 4,
            css: '.answer{' +
                '    padding: 30px 0;' +
                '  }' +
                '  .answer h3{' +
                '    font-size:32px;' +
                '    color:#333;' +
                '    text-align: center;' +
                '    line-height:53px;' +
                '    margin-bottom: 20px;' +
                '  }' +
                '  .answer p{' +
                '    font-size:14pt;' +
                '    color:#666666;' +
                '    line-height:32px;' +
                '    line-height:32px;' +
                '    text-indent: 2em;' +
                '  }' +
                '.answer b{' +
                '    color: #666666;' +
                '    font-weight: 600;' +
                '    line-height:32px;' +
                '    text-indent: 2em;' +
                '    font-size:18px;' +
                '  }' +
                '  .answer p em{' +
                '    color: #C00000;' +
                '    font-style: normal;' +
                '  }' +
                '  .answer h6 em{' +
                '    color: #FF0000;' +
                '    font-style: normal;' +
                '  }' +
                '  .mb20{' +
                '    margin-bottom: 20px;' +
                '  }' +
                '  .m10{' +
                '    margin-top: 10px;' +
                '  }' +
                '  .answer h5{' +
                '    font-size:24px;' +
                '    color:#666666;' +
                '    margin: 20px 0;' +
                '    font-weight: bold;' +
                '  }' +
                '  .answer .title1{' +
                '    font-size:28px;' +
                '    margin: 20px 0;' +
                '    text-indent: 0;' +
                '  }' +
                '  .answer .title2{' +
                '    margin-top: 20px;' +
                '  }' +
                '  .anli h4,.tip h4{' +
                '    color: #FF0000;' +
                '    font-size:18px;' +
                '    line-height:42px;' +
                '    margin-top: 20px;' +
                '  }' +
                '  .anli dd{' +
                '    color: #2B96FE;' +
                '    font-size: 18px;' +
                '    line-height: 32px;' +
                '    text-indent: 2em;' +
                '  }' +
                '  .answer .tip p{' +
                '    font-size: 18px;' +
                '    color: #666666;' +
                '    line-height: 26px;' +
                '  }',
            body: content
        };

        var me = this;
        this.data.set('arr.content', content);
        Api("post", window.Apipath.createDoc(), JSON.stringify(params2)).then(function (response) {
            if (response) {
                var domain;
                if (document.domain.indexOf('test2') != -1) {
                    domain = "test2.shiduai.com";
                } else if (document.domain.indexOf('test') != -1) {
                    domain = "test2.shiduai.com";
                } else {
                    domain = "v.shiduai.com";
                }
                me.data.set('uid', response.uid);
                var baseUrl = "http://" + domain + "/#/bgzxDoc?uid=" + response.uid;
                document.getElementById('qrcode').innerHTML = '';
                window.qrcode = new QRCode('qrcode', {
                    text: baseUrl,
                    width: 200,
                    height: 200
                });
                Api("post", window.Apipath.getCodeInfo(), JSON.stringify({ 'uid': me.data.get('uid') })).then(function (resp) {
                    if (resp) {
                        me.data.set('url', resp.resp.url);
                        me.modelSelect(me.data.get('askType'), me.data.get('qType'), "CREATE_CONSULT_WORD", me.data.get('arr'));
                        console.log(me.data.get('arr'));
                    }
                });
            } else {
                me.data.set('showAlert', false);
            }
        })
    },
    modelSelect: function (t, id, c, arr) {
        var model, visitModel, visitModelName;
        switch (t) {
          case '1':
            model = "SCENE_CONSULT-JTSG";
            break;
          case '2':
              model = "SCENE_CONSULT-HYJT";
              break;
          case '3':
              model = "SCENE_CONSULT-LDZY";
              break;
          case '4':
              model = "SCENE_CONSULT-CPZL";
              break;
          case '5':
              model = "SCENE_CONSULT-QQJF";
              break;
          case '6':
              model = "SCENE_CONSULT-FCMM";
              break;
          case '7':
              model = "SCENE_CONSULT-MJJD";
              break;
          case '8':
              model = "SCENE_CONSULT-MMHT";
              break;
          case '9':
              model = "SCENE_CONSULT-GSCS";
              break;
          default:
              model = "SCENE_CONSULT";
        }
        switch (parseInt(id)) {
          case '101':
            visitModel = "SCENE_CONSULT-JTSG-SFPCZR";
            visitModelName = "情景咨询-交通事故-谁负赔偿责任";
            break;
          case '201':
              visitModel = "SCENE_CONSULT-HYJT-LHDTJ";
              visitModelName = "情景咨询-婚姻家庭-离婚的条件";
              break;
          case '202':
              visitModel = "SCENE_CONSULT-HYJT-LHZNFYF";
              visitModelName = "情景咨询-婚姻家庭-离婚子女抚养费";
              break;
          case '203':
              visitModel = "SCENE_CONSULT-HYJT-LHZNFYQ";
              visitModelName = "情景咨询-婚姻家庭-离婚子女抚养权";
              break;
          case '204':
              visitModel = "SCENE_CONSULT-HYJT-YCYSJC";
              visitModelName = "情景咨询-婚姻家庭-遗产由谁继承";
              break;
          case '205':
              visitModel = "SCENE_CONSULT-HYJT-FQGTZWRD";
              visitModelName = "情景咨询-婚姻家庭-夫妻共同债务认定";
              break;
          case '206':
              visitModel = "SCENE_CONSULT-HYJT-LHFCFG";
              visitModelName = "情景咨询-婚姻家庭-离婚房产分割";
              break;
          case '301':
              visitModel = "SCENE_CONSULT-LDZY-SBSLDGX";
              visitModelName = "情景咨询-劳动争议-是不是劳动关系";
              break;
          case '302':
              visitModel = "SCENE_CONSULT-LDZY-SBGZJF";
              visitModelName = "情景咨询-劳动争议-双倍工资纠纷";
              break;
          case '303':
              visitModel = "SCENE_CONSULT-LDZY-JJBCJF";
              visitModelName = "情景咨询-劳动争议-经济补偿纠纷";
              break;
          case '304':
              visitModel = "SCENE_CONSULT-LDZY-LDBCJF";
              visitModelName = "情景咨询-劳动争议-劳动报酬纠纷";
              break;
          case '305':
              visitModel = "SCENE_CONSULT-LDZY-GSRDZY";
              visitModelName = "情景咨询-劳动争议-工伤认定争议";
              break;
          case '306':
              visitModel = "SCENE_CONSULT-LDZY-SHBXJF";
              visitModelName = "情景咨询-劳动争议-社会保险纠纷";
              break;
          case '307':
              visitModel = "SCENE_CONSULT-LDZY-SYQJF";
              visitModelName = "情景咨询-劳动争议-试用期纠纷";
              break;
          case '308':
              visitModel = "SCENE_CONSULT-LDZY-WYJJF";
              visitModelName = "情景咨询-劳动争议-违约金纠纷";
              break;
          case '401':
              visitModel = "SCENE_CONSULT-CPZL-CPZL";
              visitModelName = "情景咨询-产品质量-产品质量";
              break;
          case '501':
              visitModel = "SCENE_CONSULT-QQJF-GYQQ";
              visitModelName = "情景咨询-侵权纠纷-雇佣侵权";
              break;
          case '601':
              visitModel = "SCENE_CONSULT-FCMM-RGSWT";
              visitModelName = "情景咨询-房产买卖-认购书问题";
              break;
          case '602':
              visitModel = "SCENE_CONSULT-FCMM-YFEMWT";
              visitModelName = "情景咨询-房产买卖-一房二卖问题";
              break;
          case '603':
              visitModel = "SCENE_CONSULT-FCMM-MJWC";
              visitModelName = "情景咨询-房产买卖-面积误差";
              break;
          case '604':
              visitModel = "SCENE_CONSULT-FCMM-YQBZ";
              visitModelName = "情景咨询-房产买卖-逾期办证";
              break;
          case '605':
              visitModel = "SCENE_CONSULT-FCMM-YQJF";
              visitModelName = "情景咨询-房产买卖-逾期交房";
              break;
          case '701':
              visitModel = "SCENE_CONSULT-MJJD-HKJF";
              visitModelName = "情景咨询-民间借贷-还款纠纷";
              break;
          case '801':
              visitModel = "SCENE_CONSULT-MMHT-HWMMHTJF";
              visitModelName = "情景咨询-买卖合同-货物买卖合同纠纷";
              break;
          case '901':
              visitModel = "SCENE_CONSULT-GSCS-GSSLGCZDMSZRCD";
              visitModelName = "情景咨询-公司财税-公司设立过程中的民事责任承担";
              break;
          default:
            visitModel = "";
            visitModelName = "";
        }
        window.NewLog._saveLog(model, "", visitModel, visitModelName, c, arr);
    },
    modalSure: function () {
        this.data.set('showFlag', 1);
        if (this.data.get('email') == '') {
            this.data.set('tipMessage', '邮箱不能为空');
            this.data.set('seedFail', true);
            return;
        }
        var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
        if (!reg.test(this.data.get('email'))) {
            this.data.set('tipMessage', '邮箱格式不正确');
            this.data.set('seedFail', true);
            return;
        }
        this.data.set('loading1', true);
        this.modelSelect(this.data.get('askType'), this.data.get('qType'), "SEND_MAIL");
        var me = this;
        me.data.set('showAlert', false);
        Api("post", window.Apipath.sendNewMail(), JSON.stringify({ 'uid': this.data.get('uid'), 'toAddress': this.data.get('email'), 'name': "法律咨询意见书", 'remoteFile': this.data.get('url') })).then(function (response) {
            // me.data.set('email', '');
            if (response.code == 0) {
                me.data.set('loading1', false);
                console.log(response, 999999)
                me.data.set('showAlert', false);
                me.dispatch('showAlert', { title: '提示', msg: "发送成功" });
            } else {
                me.data.set('loading1', false);
                me.data.set('showAlert', false);
                me.dispatch('showAlert', { title: '提示', msg: response.msg });
            }
        });
    },
    mail: function () {
        this.data.set('showAlert', true);
    },
    cancel: function () {
        this.data.set('showAlert', false);
    },
    goElv: function () {
        this.data.set('evaluateAlert', true);
    },
    dianzan: function (elv) {
        if (this.data.get('evaluateState') != elv) {
            this.data.set('evaluateState', elv);
        } else {
            this.data.set('evaluateState', 0);
        }
        var req = {
            uid: this.data.get('uid'),
            evaluateState: this.data.get('evaluateState')
        };
        Api("post", "/api/writ/v2/evaluate", JSON.stringify(req)).then(function (response) {

        });
    },
    messages: {
        sureBtn: function (req) {
            var me = this;
            req.value.logId = window.NewLog._data.logId;
            req.value.uid = this.data.get('uid');
            this.data.set('evaluateAlert', false);
            Api("post", "/api/writ/v2/evaluate", JSON.stringify(req.value)).then(function (response) {
                me.data.set('evaluateState', 5);
            })
        },
        cancel: function () {
            this.data.set('evaluateAlert', false);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/qjzxAnswer.js
// module id = 363
// module chunks = 1